import classnames from 'classnames';
import classes from './SmallScreenFilters.module.scss';
import ScrollBound from 'react-scroll-bound';
import { FormattedMessage } from 'react-intl';
import React, { useCallback, useState } from 'react';
import { Drawer, Form } from 'antd';
import { IconImage, GlobalIcon } from 'src/modules/global';
import { AccordionMultiSelect } from 'src/modules/form/field/AccordionMultiSelect/AccordionMultiSelect';
import { GenericFiltersProps } from 'src/modules/form/field/filters/types';
import { Button } from 'src/modules/global/components/button/Button';

export const SmallScreenFilters = ({ form, filters }: GenericFiltersProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const openFiltersModal = useCallback(() => {
    setIsOpen(true);
  }, [setIsOpen]);

  const closeFiltersModal = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  const applyFilters = useCallback(() => {
    form.submit();
    closeFiltersModal();
  }, [closeFiltersModal, form]);

  const resetFilters = useCallback(() => {
    form.setFieldsValue({
      categories: [],
      locationTypes: [],
    });
    form.submit();
    closeFiltersModal();
  }, [closeFiltersModal, form]);

  const getSelectedFiltersCount = (getFieldValue) => {
    return Object.keys(filters).reduce((sum, filterFormName) => {
      return sum + getFieldValue(filterFormName).length;
    }, 0);
  };

  return (
    <div className={classes.container}>
      <Form.Item shouldUpdate={() => true} className={classes.formItem}>
        {({ getFieldValue }) => {
          const enabledFiltersNum = getSelectedFiltersCount(getFieldValue);

          return (
            <>
              <span className={classes.openFiltersModalButton} onClick={openFiltersModal}>
                <FormattedMessage id="filters/buttons/open_filters_modal" />

                {!!enabledFiltersNum && ` (${enabledFiltersNum})`}
                <GlobalIcon
                  className={classes.openFiltersModalButtonIcon}
                  image={isOpen ? IconImage.Minus : IconImage.Plus}
                />
              </span>
            </>
          );
        }}
      </Form.Item>
      <Drawer
        className={classes.drawer}
        width="100%"
        placement="right"
        visible={isOpen}
        closable={false}
        headerStyle={{ height: 0, overflow: 'hidden' }}>
        <div className={classes.drawerInnerContainer}>
          <div className={classes.titleBar}>
            <div className={classes.titleLabel}>
              <FormattedMessage id="filters/title" />
            </div>
            <div className={classes.closeFiltersModalButton} onClick={applyFilters}>
              <GlobalIcon
                image={IconImage.Close}
                size="custom"
                className={classes.closeFiltersModalButtonIcon}
              />
            </div>
          </div>
          <ScrollBound className={classes.filtersContainer} tagName="div">
            {Object.entries(filters).map(([filterFormName, filter]) => (
              <Form.Item key={filterFormName} name={filterFormName} className={classes.formItem}>
                <AccordionMultiSelect titleKey={filter.labelKey} filters={filter.items} />
              </Form.Item>
            ))}
          </ScrollBound>
          <Form.Item shouldUpdate={() => true} className={classes.formItem} noStyle={true}>
            {({ getFieldValue }) => {
              const enabledFiltersNum = getSelectedFiltersCount(getFieldValue);

              return (
                <div className={classes.buttons}>
                  <div
                    onClick={!!enabledFiltersNum && resetFilters}
                    className={classnames(
                      classes.resetButton,
                      !enabledFiltersNum && classes.resetButtonDisabled
                    )}>
                    <FormattedMessage id="filters/buttons/mobile/reset" />
                  </div>

                  <Button
                    onClick={applyFilters}
                    type="primary"
                    className={classes.applyFiltersButton}>
                    <FormattedMessage id="filters/buttons/mobile/save" />
                  </Button>
                </div>
              );
            }}
          </Form.Item>
        </div>
      </Drawer>
    </div>
  );
};
